import styled, {css} from 'styled-components';

// icons
import SearchInputIcon from '../../../../verticals/hotels-dweb/src/stories/Icons/SearchInputIcon';

const SearchBarContainer = styled.div<{$$isReadOnly: boolean}>`
  display: flex;
  align-items: center;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 1.2rem;
  padding: 8px 16px;
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  ${({$$isReadOnly}) =>
    $$isReadOnly &&
    css`
      cursor: pointer;
    `}
`;

const SearchInput = styled.input<{$$isReadOnly: boolean}>`
  border: none;
  outline: none;
  font-size: 16px;
  flex: 1;

  ${({$$isReadOnly}) =>
    $$isReadOnly &&
    css`
      cursor: pointer;
    `}

  &::placeholder {
    color: #b0b0b0;
  }
`;

const SearchIconWrap = styled(SearchInputIcon)`
  width: 2rem;
  height: 2rem;
  margin-right: ${({theme}) => theme.spacing.large};
  fill: ${({theme}) => theme.colors.downriver.medium};
  margin-top: ${({theme}) => theme.spacing.custom(3)};
`;

const SearchBar = ({placeholder = 'Search', onToggleInput, onChangeInput}) => {
  const isReadOnly = !onChangeInput;

  return (
    <SearchBarContainer onClick={onToggleInput} $$isReadOnly={isReadOnly}>
      <SearchIconWrap />
      <SearchInput
        $$isReadOnly={isReadOnly}
        type="text"
        placeholder={placeholder}
        onChange={onChangeInput || (() => {})}
        readOnly={isReadOnly}
      />
    </SearchBarContainer>
  );
};

export default SearchBar;
